import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import socketService from './services/socket';
import './App.css';

// Páginas
import Home from './pages/Home';
import CreateGame from './pages/CreateGame';
import JoinGame from './pages/JoinGame';
import WaitingRoom from './pages/WaitingRoom';
import Game from './pages/Game';
import Results from './pages/Results';
import AdminCampos from './pages/AdminCampos';

function App() {
  useEffect(() => {
    // Conectar socket al montar la aplicación
    socketService.connect();

    // Desconectar al desmontar
    return () => {
      socketService.disconnect();
    };
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/crear" element={<CreateGame />} />
          <Route path="/unirse/:codigo?" element={<JoinGame />} />
          <Route path="/sala/:codigo" element={<WaitingRoom />} />
          <Route path="/juego/:codigo" element={<Game />} />
          <Route path="/resultados/:codigo" element={<Results />} />
          <Route path="/admin/campos" element={<AdminCampos />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
